import React, { createContext, forwardRef } from 'react';
export const AvatarContext = createContext({});
export const Avatar = (StyledAvatar) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAvatar ref={ref} {...props}>
        {children}
      </StyledAvatar>);
});
